import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";

enum Action {
    GetContact
}

interface IContactResult {
    success: boolean,
    errors: Array<string>,
}

export class ContactView {
    public constructor() {
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".get-contact",
            data: {
                success: false,
                fullName: "",
                email: "",
                content: "",
                errors: new Array()
            },
            methods: {
                contact() {
                    var data = {
                        FullName: v.fullName,
                        Email: v.email,
                        Content: v.content
                    };

                    ajax(Uri.getUri(Action[Action.GetContact]), { dataType: "json", method: "post", data: data })
                        .done((res: IContactResult) => {
                            if (!res) {
                                return;
                            }

                            if (res.success) {
                                v.success = true;
                            } else {
                                v.errors = res.errors;
                            }
                        });
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Shared/ContactView.ts